export enum ErrorReturnMessage {
    totals = "Unable to obtain query totals",
    results = "Unable to obtain results"
};
export interface IQueryInput {
    TableViewID: number,
    SearchID: number,
    SearchValue?: string
};  
export interface IQueryInformation {
    tableViewName: string,
    description: string,
    screenName: string,
    tableKeyColumn: string,
    screenKeyColumn: string,
    minFrameSize: number,
    searchID: number
};
export interface IQueryMenuItems {
    actionType: string,
    menuID: number,
    label: string
}
export interface IQueryColumns {
    displayOrder: number,
    columnName: string,
    columnTitle: string,
    convertedDataType: string,
    trueDataType: string,
    isSearchable: boolean,
    isHidden: number
};

export interface IQueryTotals {
    searchID: number,
    description: string,
    totalCount: number
};
export interface IQuerySetupResponse {
    setupData: IQueryInformation,
    menuList: IQueryMenuItems[],
    columnList: IQueryColumns[],
    totalList: IQueryTotals[],
    resultList: any[]
};
export interface IQueryTotalResponse {
    totalList: IQueryTotals[]
};
export interface IQuerySearchResponse {
    resultList: any[]
};